export interface ICsvRecord
{ 
    Name: string, 
    Size?: number,
    RecordCount?: number,
    ValidationMessage?: string,
    Success: boolean,
    Data?: any
};
export enum  CsvColumnCleanup {     
    String = `,"`,
    AmountCharacters = `,"$`,
    NumberOnly = `{N}`, 
}